
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { AccountModal, SettingsModal } from '@/lazy-load-components';

import { ModalHelper } from '@/helpers/modal-helper';
import BasicButton from '@/ui-components/BasicButton.vue';
import { faUserCog } from '@fortawesome/free-solid-svg-icons';

const User = namespace('user');

@Component({
	name: 'LoginMenuButtonNew',
	components: {
		BasicButton,
	},
})
export default class LoginMenuButtonNew extends Vue {
	faUserCog = faUserCog;

	@Prop({ type: Boolean, default: false }) dark: boolean;

	@User.State loginProgress: boolean;

	@User.Getter isLoggedIn: boolean;
	@User.Mutation SET_LOGIN_PROGRESS: (value: boolean) => void;

	handleAccountClick() {
		ModalHelper.openModal(SettingsModal);
	}

	handleLoginClick() {
		ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'login-modal' }, '', false, [], () =>
			this.SET_LOGIN_PROGRESS(false)
		);
	}
}
